import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var ExternalIdentifierTypeDtoNameInline;
(function (ExternalIdentifierTypeDtoNameInline) {
    ExternalIdentifierTypeDtoNameInline["INT64"] = "INT64";
})(ExternalIdentifierTypeDtoNameInline || (ExternalIdentifierTypeDtoNameInline = {}));
export var FeatureToggleDtoKeyInline;
(function (FeatureToggleDtoKeyInline) {
    FeatureToggleDtoKeyInline["INTERNAL_ACCOUNT"] = "INTERNAL_ACCOUNT";
})(FeatureToggleDtoKeyInline || (FeatureToggleDtoKeyInline = {}));
export var EntityType;
(function (EntityType) {
    EntityType["ACCOUNT"] = "ACCOUNT";
    EntityType["CONTACT"] = "CONTACT";
})(EntityType || (EntityType = {}));
export var CampaignPositionType;
(function (CampaignPositionType) {
    CampaignPositionType["DIGITAL"] = "DIGITAL";
    CampaignPositionType["PRINT"] = "PRINT";
    CampaignPositionType["RADIO"] = "RADIO";
    CampaignPositionType["TV"] = "TV";
    CampaignPositionType["POSTNETZ_ANALOG"] = "POSTNETZ_ANALOG";
    CampaignPositionType["POS"] = "POS";
})(CampaignPositionType || (CampaignPositionType = {}));
export var MailchimpStatus;
(function (MailchimpStatus) {
    MailchimpStatus["SUBSCRIBED"] = "SUBSCRIBED";
    MailchimpStatus["UNSUBSCRIBED"] = "UNSUBSCRIBED";
    MailchimpStatus["CLEANED"] = "CLEANED";
    MailchimpStatus["NOT_SYNC"] = "NOT_SYNC";
})(MailchimpStatus || (MailchimpStatus = {}));
export var Invoicing;
(function (Invoicing) {
    Invoicing["NONE"] = "NONE";
    Invoicing["AFTER_RUNTIME"] = "AFTER_RUNTIME";
    Invoicing["START_RUNTIME"] = "START_RUNTIME";
    Invoicing["IMMEDIATELY"] = "IMMEDIATELY";
    Invoicing["BY_DELIVERY_500"] = "BY_DELIVERY_500";
    Invoicing["BY_POSITION_END_DATE_MONTH"] = "BY_POSITION_END_DATE_MONTH";
    Invoicing["BY_POSITION_END_DATE_QUARTER"] = "BY_POSITION_END_DATE_QUARTER";
    Invoicing["BY_POSITION_END_DATE_HALFYEAR"] = "BY_POSITION_END_DATE_HALFYEAR";
})(Invoicing || (Invoicing = {}));
export var Gender;
(function (Gender) {
    Gender["MALE"] = "MALE";
    Gender["FEMALE"] = "FEMALE";
})(Gender || (Gender = {}));
export var FormOfCommunication;
(function (FormOfCommunication) {
    FormOfCommunication["INFORMAL"] = "INFORMAL";
    FormOfCommunication["FORMAL"] = "FORMAL";
})(FormOfCommunication || (FormOfCommunication = {}));
export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["DE"] = "DE";
    LanguageCode["EN"] = "EN";
    LanguageCode["FR"] = "FR";
    LanguageCode["IT"] = "IT";
})(LanguageCode || (LanguageCode = {}));
export var InvoiceDeliveryType;
(function (InvoiceDeliveryType) {
    InvoiceDeliveryType["POSTAL"] = "POSTAL";
    InvoiceDeliveryType["DIGITAL"] = "DIGITAL";
})(InvoiceDeliveryType || (InvoiceDeliveryType = {}));
export var DiscountType;
(function (DiscountType) {
    DiscountType["BROKER_COMMISSION"] = "BROKER_COMMISSION";
    DiscountType["CONSULTANCY_COMMISSION"] = "CONSULTANCY_COMMISSION";
    DiscountType["DBE_DISCOUNT"] = "DBE_DISCOUNT";
    DiscountType["YEARLY_DISCOUNT"] = "YEARLY_DISCOUNT";
})(DiscountType || (DiscountType = {}));
export var EmailAddressType;
(function (EmailAddressType) {
    EmailAddressType["SCREENSHOT"] = "SCREENSHOT";
    EmailAddressType["REPORT"] = "REPORT";
    EmailAddressType["INVOICE"] = "INVOICE";
    EmailAddressType["CREATIVE"] = "CREATIVE";
    EmailAddressType["SUGGESTION"] = "SUGGESTION";
})(EmailAddressType || (EmailAddressType = {}));
export var ContactRole;
(function (ContactRole) {
    ContactRole["SALES"] = "SALES";
    ContactRole["CUSTOMER"] = "CUSTOMER";
})(ContactRole || (ContactRole = {}));
export var AccountRole;
(function (AccountRole) {
    AccountRole["ADVERTISER"] = "ADVERTISER";
    AccountRole["BROKER"] = "BROKER";
    AccountRole["AGENCY"] = "AGENCY";
    AccountRole["OTHER"] = "OTHER";
    AccountRole["PUBLISHER"] = "PUBLISHER";
})(AccountRole || (AccountRole = {}));
export var ImportStatus;
(function (ImportStatus) {
    ImportStatus["PROCESSING"] = "PROCESSING";
    ImportStatus["SUCCESS"] = "SUCCESS";
    ImportStatus["ERROR"] = "ERROR";
})(ImportStatus || (ImportStatus = {}));
export var ReportingType;
(function (ReportingType) {
    ReportingType["WEEKLY"] = "WEEKLY";
    ReportingType["BY_END_DATE"] = "BY_END_DATE";
    ReportingType["FLIGHT_EXPIRATION"] = "FLIGHT_EXPIRATION";
    ReportingType["MANUAL"] = "MANUAL";
})(ReportingType || (ReportingType = {}));
